import type { ColDef, ICellRendererParams, IRowNode } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';
import { ProductSalesCellRenderer } from '~/components/product';

import { formatDate } from '~/utils/date';

import type { TypeMappingProduct } from '~/types/product.types';

/**
 * [상품 판매처 매핑] 페이지 > 테이블 컬럼 정의
 */
const getProductMappingColumnDefs = ({
  onClickAddSalesChannel,
  onClickViewDetail,
}: {
  onClickAddSalesChannel: (node: IRowNode<TypeMappingProduct>) => Promise<void>;
  onClickViewDetail: (node: IRowNode<TypeMappingProduct>) => Promise<void>;
}) => {
  const columnDefs: ColDef<TypeMappingProduct>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'skuActiveType',
      headerName: '상품 운영 구분',
      width: 120,
    },
    {
      field: 'skuName',
      headerName: '컬리 상품명',
      minWidth: 240,
      flex: 1,
    },
    {
      field: 'skuCode',
      headerName: '컬리 상품코드',
      width: 140,
    },
    {
      field: 'createdDate',
      headerName: '상품 등록일',
      width: 100,
      valueFormatter: ({ value }: { value: Date }) => formatDate(value, 'YYYY.MM.DD') ?? '-',
    },
    {
      headerName: '',
      minWidth: 92,
      width: 92,
      cellRenderer: (node: IRowNode) => ProductSalesCellRenderer(node, onClickAddSalesChannel),
      valueFormatter: () => '판매처 추가',
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      field: 'salesChannelName',
      headerName: '판매처',
      width: 148,
    },
    {
      field: 'salesChannelCode',
      headerName: '판매처 코드',
      width: 140,
    },
    {
      field: 'salesChannelSkuName',
      headerName: '판매처 상품명',
      width: 240,
    },
    {
      field: 'salesChannelSkuCode',
      headerName: '판매처 상품 코드',
      width: 140,
    },
    {
      headerName: '',
      minWidth: 80,
      width: 80,
      cellRenderer: TextButtonCell,
      cellRendererParams: ({ data }: ICellRendererParams<TypeMappingProduct>) => ({
        children: '상세보기',
        showDashIfNoValue: false,
        disabled: !(
          data?.salesChannelName &&
          data?.salesChannelCode &&
          data?.salesChannelSkuName &&
          data?.salesChannelSkuCode
        ),
        onClick: (node: IRowNode<TypeMappingProduct>) => onClickViewDetail(node),
      }),
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
  ];

  return { columnDefs };
};

export default getProductMappingColumnDefs;
